module.exports = __webpack_public_path__ + "4256feb9b562141f4066a868e3087a32.svg";